export default {
  UN_SAVE: '信息尚未保存，确认离开？',
  SAVE_DRAFT: '保存草稿',
  BUY_PACKAGE_DRAFT: '存为草稿并购买',
  SET_DRAFT: '存为草稿并设置'
}
